<template>
  <div class="sp-template">
    <div class="h-title">查看订单</div>
    <el-card class="box-card">
      <h3 class="sp-card-title">基本信息</h3>
      <el-form :model="form" size="small" inline>
        <el-form-item label="订单号" label-width="80px">{{form.id}}</el-form-item>
        <el-form-item v-show="false" label="客户" label-width="80px">{{form.customerName}}</el-form-item>
        <el-form-item label="产品" label-width="80px">{{form.productName}}</el-form-item>
        <el-form-item label="取件方式" label-width="80px">{{form.deliveryTypeName}}</el-form-item>
        <el-form-item label="下单时间" label-width="80px">{{form.createAt}}</el-form-item>
        <el-form-item label="一般贸易" label-width="80px">{{form.generalTrade ? "是":"否"}}</el-form-item>
      </el-form>
      <h3 class="sp-card-title">进度跟踪</h3>
      <div style="padding:0 2%;margin-bottom: 20px;">
        <el-row>
          <el-col :span="14">
            <el-steps :active="active" finish-status="success">
              <el-step v-for="(d,i) in form.taskStages" :key="i" :title="d.stageName"></el-step>
            </el-steps>
          </el-col>
          <el-col :span="14">
            <el-card class="m-t-20">
              <div slot="header" class="clearfix">
                <span>进度详情</span>
              </div>
              <div v-for="(d,i) in form.trackingValues" :key="i" class="text item">
                {{d.at}}&nbsp;&nbsp;
                <b>{{d.eventName}} {{!d.trackingNo?"":"["+d.trackingNo+"]"}}</b>&nbsp;&nbsp;{{d.detail}}
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div class="m-b-10">
        <el-button size="small" type="text" @click="show = !show">查看订单详情</el-button>
      </div>
      <el-collapse-transition>
        <div v-show="show">
          <h3 class="sp-card-title">订单信息</h3>
          <el-form :model="form" size="small">
            <el-row v-show="!fbaChecked">
              <el-col :span="10">
                <el-form-item v-show="false" label="是否是FBA地址" :label-width="formLabelWidth">是</el-form-item>
                <el-form-item label="客户单号" :label-width="formLabelWidth">{{form.customerRefnumber.customerOrderNumber}}</el-form-item>
                <el-form-item label="联系电话" :label-width="formLabelWidth">{{form.shippingDetail.contractDatail.phone}}</el-form-item>
                <el-form-item label="州/省" :label-width="formLabelWidth">{{form.shippingDetail.address.province}}</el-form-item>
                <el-form-item label="城市" :label-width="formLabelWidth">{{form.shippingDetail.address.city}}</el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="FBA号" :label-width="formLabelWidth">{{form.customerRefnumber.fbaNumber}}</el-form-item>
                <el-form-item label="联系人" :label-width="formLabelWidth">{{form.shippingDetail.contractDatail.name}}</el-form-item>
                <el-form-item label="国家" :label-width="formLabelWidth">{{form.shippingDetail.address.country}}</el-form-item>
                <el-form-item label="邮编" :label-width="formLabelWidth">{{form.shippingDetail.address.zipcode}}</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="详细地址1" :label-width="formLabelWidth">{{form.shippingDetail.address.address}}</el-form-item>
                <el-form-item label="详细地址2" :label-width="formLabelWidth">{{form.shippingDetail.address.address2}}</el-form-item>
              </el-col>
            </el-row>
            <el-row v-show="fbaChecked">
              <el-col :span="10">
                <el-form-item label="是否是FBA地址" :label-width="formLabelWidth">否</el-form-item>
                <el-form-item label="客户单号" :label-width="formLabelWidth">213212</el-form-item>
                <el-form-item label="FBA仓码" :label-width="formLabelWidth">213212</el-form-item>
                <el-form-item label="目的邮编" :label-width="formLabelWidth">213212</el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="FBA号" :label-width="formLabelWidth">213212</el-form-item>
                <el-form-item label="目的国家" :label-width="formLabelWidth">213212</el-form-item>
                <el-form-item label="目的城市" :label-width="formLabelWidth">213212</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="详细地址" :label-width="formLabelWidth">213212</el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <h3 class="sp-card-title">商品信息</h3>
          <el-form :model="form" size="small">
            <el-row>
              <el-col :span="10">
                <el-form-item label="货物类型" :label-width="formLabelWidth">{{form.goodsTypeName}}</el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="货物箱数" :label-width="formLabelWidth">{{form.packingList.totalCarton}}</el-form-item>
              </el-col>
            </el-row>
            <el-table :data="form.packingList.cartonDetails" class="m-b-20">
              <el-table-column property="cartonNumber" label="系统箱号"></el-table-column>
              <el-table-column property="customerCartonNumber" label="客户箱号"></el-table-column>
              <el-table-column property="length" label="长(cm)"></el-table-column>
              <el-table-column property="width" label="宽(cm)"></el-table-column>
              <el-table-column property="height" label="高(cm)"></el-table-column>
              <el-table-column property="weight" label="毛重(kg)"></el-table-column>
              <el-table-column label="SKU信息">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" @click="showSku(scope.row)">查看SKU</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-row>
              <el-col :span="10">
                <el-form-item label="总体积" :label-width="formLabelWidth">{{totalVolume.toFixed(4)}} cbm</el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="总重量" :label-width="formLabelWidth">{{totalWeight.toFixed(4)}} kg</el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-collapse-transition>
      <el-button size="small" @click="back">返 回</el-button>
    </el-card>
    <!-- SKU -->
    <el-dialog class="sp-info-box" title="商品信息" :visible.sync="listTable" @close="listTable = false">
      <div class="">
        <el-table :data="spList" tooltip-effect="dark" style="width: 100%">
          <el-table-column prop="sku" label="SKU"></el-table-column>
          <el-table-column prop="qty" label="数量"></el-table-column>
          <el-table-column prop="nameCn" label="中文品名"></el-table-column>
          <el-table-column prop="nameEn" label="英文品名"></el-table-column>
          <el-table-column prop="length" label="长(cm)"></el-table-column>
          <el-table-column prop="width" label="宽(cm)"></el-table-column>
          <el-table-column prop="height" label="高(cm)"></el-table-column>
          <el-table-column prop="singleNetWeight" label="单个净重(kg)"></el-table-column>
          <el-table-column prop="weight" label="单个毛重(kg)"></el-table-column>
          <el-table-column prop="hscode" label="中国海关编码"></el-table-column>
          <el-table-column prop="euHsCode" label="欧盟海关编码"></el-table-column>
          <el-table-column prop="brand" label="品牌"></el-table-column>
          <el-table-column prop="material" label="材质"></el-table-column>
          <el-table-column prop="purpose" label="用途"></el-table-column>
          <el-table-column prop="asin" label="ASIN或销售链接"></el-table-column>
          <el-table-column prop="model" label="型号"></el-table-column>
          <el-table-column prop="currency" label="币种"></el-table-column>
          <el-table-column prop="price" label="申报价值"></el-table-column>
          <el-table-column label="图片">
            <template slot-scope="scope">
              <img :src="scope.row.picture" style="width: 50px;height: 50px;" />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog class="sp-info-box" title="详情" :visible.sync="detailTable" @close="detailTable = false">
      <div class="">
        <el-table :data="detialList" tooltip-effect="dark" style="width: 100%">
          <el-table-column prop="cartonNumber" label="箱号"></el-table-column>
          <el-table-column prop="length" label="长(cm)"></el-table-column>
          <el-table-column prop="width" label="宽(cm)"></el-table-column>
          <el-table-column prop="height" label="宽(cm)"></el-table-column>
          <el-table-column prop="weight" label="重量(kg)"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      guigeRadio: "1",
      formLabelWidth: "120px",
      fbaChecked: false,
      productChecked: false,
      form: {
        customerRefnumber: { customerOrderNumber: "", fbaNumber: "" },
        shippingDetail: {
          address: {
            province: "",
            country: "",
            city: "",
            address: "",
            address2: ""
          },
          contractDatail: { phone: "", name: "" }
        },
        packingList: {
          goodsType: "",
          totalCarton: ""
        }
      },
      listTable: false,
      spList: [],
      totalVolume: 0,
      totalWeight: 0,
      guigeArr: [
        {
          number: "12",
          long: "12",
          width: "12",
          height: "12",
          weight: "12"
        }
      ],
      active: 0,
      detailTable: false,
      detialList: []
    };
  },
  created() {
    let _this = this;
    setTimeout(function() {
      _this.loadData();
    }, 500);
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    showSku(row) {
      //显示sku
      let _this = this;
      _this.listTable = true;
      let _skus = new Array();
      row.items.forEach((d, i) => {
        _skus.push(d.sku);
      });

      _this.$request1
        .get(
          '/skus',
          {
            withCredentials: true,
            params: {
              skus: _skus
            }
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.spList = new Array();
            res.data.data.forEach((d, i) => {
              row.items.forEach((rd, ri) => {
                if (rd.sku == d.sku) {
                  d.qty = rd.qty;
                  _this.spList.push(d);
                }
              });
            });
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    loadData() {
      let _this = this;
      let _id = _this.$route.query.id;
      if (!_id || _id == "") {
        _this.$message.error("id not found!");
        return false;
      }
      _this.$request1
        .post(
          '/order/query',
          {
              status: "",
              productId: "",
              orderId: _id,
              startDate: "",
              endDate: "",
              currentPage: 1,
              pageSize: 1
            },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          // console.log(res);
          if (res.data.success) {
            if (res.data.data && res.data.data.length > 0) {
              _this.form = res.data.data[0];
              _this.form.packingList.cartonDetails.forEach((d, i) => {
                _this.totalWeight += d.weight;
                _this.totalVolume += d.height * d.width * d.height / 1000000;
              });
              if (_this.form.customerRefnumber == null) {
                _this.form.customerRefnumber = {
                  customerOrderNumber: "",
                  fbaNumber: ""
                };
              }
              // _this.form.taskStages.forEach((d, i) => {
              //   if (d.passed) {
              //     _this.active = d.stageSeq + 1;
              //   }
              // });
            } else {
              _this.$message.error("Data not found!");
            }
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    showDetial(data) {
      let _this = this;
      _this.detialList = data;
      _this.detailTable = true;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/order/checkorder.vue